import { render } from "./ButtonAdd.vue?vue&type=template&id=1110c049&scoped=true"
import script from "./ButtonAdd.vue?vue&type=script&lang=js"
export * from "./ButtonAdd.vue?vue&type=script&lang=js"

import "./ButtonAdd.vue?vue&type=style&index=0&id=1110c049&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1110c049"]])

export default __exports__